import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

export const styles = (theme) => ({
  tab: {
    fontFamily: theme.typography.fontKanit,
    opacity: 1,
    fontWeight: 500,
    border: '1px solid #ccc',
  },
  active_tab: {
    color: 'white',
    fontFamily: theme.typography.fontKanit,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: 8,
      },
      head: {
        paddingTop: 14,
        paddingBottom: 14,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
      },
      body: {
        padding: 12,
        whiteSpace: 'nowrap',
        fontFamily: theme.typography.fontFamily,
      },
    },
  },
});

export const StyledCommentTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#ccc',

    padding: '7px',
    fontSize: '12px',
    '&:nth-of-type(even)': {
      borderRight: '2px solid #fff',
      borderLeft: '2px solid #fff',
    },
  },
}))(TableCell);

export const StyledSubTableCell = withStyles((theme) => ({
  body: {
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))(TableCell);

export const StyledFooterTableCell = withStyles(() => ({
  body: {
    backgroundColor: '#eee',
  },
}))(TableCell);

export const StyledFooterSubTableCell = withStyles(() => ({
  body: {
    backgroundColor: '#ddd',
  },
}))(TableCell);
